import { useEffect, useState, useCallback, useRef } from "react";
import {
  CaretDownOutlined,
  WarningOutlined,
  DownOutlined,
} from "@ant-design/icons";
// import { RangeStepInput } from 'react-range-step-input';
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Card, Space, Slider, Input, Button, Dropdown } from "antd";
import { Select } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
// import { useCurrentPng } from "recharts-to-png";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Label,
  Tooltip,
  LineChart,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  ReferenceLine,
} from "recharts";
import { Spin } from "antd";
import { get } from "../Libraries/Ajax/HttpService";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as htmlToImage from "html-to-image";
import back from "../assets/images/back.svg";
import { useDistrict } from "../utils/DistrictContext";
function Prediction_flow() {
  const navigate = useNavigate();
  const [optionone, setOptionone] = useState("total");
  const [datapredictions, setDatapredictions] = useState(null);
  const [prediction, setPrediction] = useState(false);
  const [percentage, setPercentage] = useState("");
  const [percentage_next, setPercentage_next] = useState("");
  const [launchDate, setLaunchDate] = useState("");
  const [nextdata, setNextdata] = useState([]);
  const [datastatusaccontability, setDatastatusaccountability] =
    useState(false);
  const [datastatusanomaly, setDatastatusanomaly] = useState(false);
  const dataPrediction = [];
  const type = "linear";
  const { selectedDistrict } = useDistrict();
  const radioChanges = (event) => {
    setOptionone(event.target.value);
  };
  const onRedirection = (event) => {
    // window.history.back();
    navigate(-1);
  };

  const handleFlowPageclick = () => {
    console.log("flow Analytics");
    navigate("/totalflow");
  };

  const handlePredictivePageclick = () => {
    console.log("Predictive Analytics");
  };
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const handleAnomalypageclick = () => {
    console.log("Anomaly Analytics");
    navigate("/Anomaly");
  };
  const normalizeFlowData = (arr, key = "Flow") =>
    arr.map((item) => ({
      ...item,
      [key]:
        item[key] !== null && item[key] !== undefined
          ? Number(String(item[key]).replace(/,/g, ""))
          : null,
    }));
  // useEffect(() => {
  //     const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //     document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //   }, []);
  // Reset selection to "total" whenever the district changes
  useEffect(() => {
    setOptionone("total");
  }, [selectedDistrict]);
  useEffect(
    () => {
      var user = JSON.parse(localStorage.getItem("MCData"));
      var userid = user?.userid;

      get(`apis/alert_status?user_id=${userid}`).then((response) => {
        console.log(response.data.data.accountability_alert_status);
        setDatastatusaccountability(
          response.data.data.accountability_alert_status,
        );
        setDatastatusanomaly(response.data.data.anomaly_alert_status);
      });
    },
    [datastatusaccontability],
    [datastatusanomaly],
    [selectedDistrict],
  );
  useEffect(() => {
    if (optionone == "total") {
      get(`apis/prediction_total`).then((response) => {
        let length =
          response.data.current_data.length +
          response.data.predicted_data.length;
        let limit = response.data.current_data.length;
        let limits = response.data.predicted_data.length;
        let percentages = 100 - ((length - limit - 1) / (length - 1)) * 100;
        const combined = response.data.combined.data;
        setPercentage(percentages);

        console.log("dataprediction", dataPrediction);

        console.log("launchdate", launchDate);
        // setDatapredictions(combined);
        setDatapredictions(normalizeFlowData(combined));
      });
      get(`apis/prediction_total_next`).then((response) => {
        let length = response.data.combined.data.length;
        let limit = response.data.current_data.length;
        let limits = response.data.predicted_data.length;
        let percentages_next =
          100 - ((length - limit - 1) / (length - 1)) * 100;
        const combined_next = response.data.combined.data;
        setPercentage_next(percentages_next);
        console.log("dataprediction", dataPrediction);
        console.log("launchdate", launchDate);
        // setNextdata(combined_next);
        setNextdata(normalizeFlowData(combined_next));
      });
    }

    if (optionone == "potable") {
      get(`apis/prediction_potable`).then((response) => {
        //  console.log("dataprediction",response.data.current_data.length);
        // setColor(response.data.color);
        let length =
          response.data.current_data.length +
          response.data.predicted_data.length;
        let limit = response.data.current_data.length;
        let limits = response.data.predicted_data.length;
        let percentages = 100 - ((length - limit - 1) / (length - 1)) * 100;
        const combined = response.data.combined.data;
        console.log("potable combined data", combined);
        setPercentage(percentages);

        for (let i = 0; i < limit; i++) {
          const week = response.data.current_data[i].week;
          const value = response.data.current_data[i].total_flow;
          let d = {
            week: week,
            // value: undefined,
            Flow: value,
          };
          dataPrediction.push(d);
        }
        setLaunchDate(response.data.predicted_data[0].week);
        for (let i = 0; i < limits; i++) {
          const week = response.data.predicted_data[i].week;
          const value = response.data.predicted_data[i].total_flow;
          let d = {
            week: week,
            Flow: value,
            // actualvalue: undefined
          };
          dataPrediction.push(d);
        }
        console.log("dataprediction", dataPrediction);

        console.log("launchdate", launchDate);
        setDatapredictions(combined);
      });
      get(`apis/prediction_potable_next`).then((response) => {
        let length = response.data.combined.data.length;
        let limit = response.data.current_data.length;
        let limits = response.data.predicted_data.length;
        let percentages_next =
          100 - ((length - limit - 1) / (length - 1)) * 100;
        const combined_next = response.data.combined.data;
        setPercentage_next(percentages_next);

        console.log("dataprediction", dataPrediction);

        console.log("launchdate", launchDate);
        setNextdata(combined_next);
      });
    }

    if (optionone == "non_potable") {
      get(`apis/prediction_non_potable`).then((response) => {
        let length =
          response.data.current_data.length +
          response.data.predicted_data.length;
        let limit = response.data.current_data.length;
        let limits = response.data.predicted_data.length;
        let percentages = 100 - ((length - limit - 1) / (length - 1)) * 100;
        const combined = response.data.combined.data;
        console.log("last combined data", combined);
        setPercentage(percentages);
        for (let i = 0; i < limit; i++) {
          const week = response.data.current_data[i].week;
          const value = response.data.current_data[i].total_flow;
          let d = {
            week: week,
            // value: undefined,
            Flow: value,
          };
          dataPrediction.push(d);
        }
        setLaunchDate(response.data.predicted_data[0].week);
        for (let i = 0; i < limits; i++) {
          const week = response.data.predicted_data[i].week;
          const value = response.data.predicted_data[i].total_flow;
          let d = {
            week: week,
            Flow: value,
            // actualvalue: undefined
          };
          dataPrediction.push(d);
        }
        console.log("datapredictionv hh  ", dataPrediction);

        console.log("launchdate", launchDate);

        setDatapredictions(combined);
      });
      get(`apis/prediction_non_potable_next`).then((response) => {
        let length = response.data.combined.data.length;
        let limit = response.data.current_data.length;
        let limits = response.data.predicted_data.length;
        let percentages_next =
          100 - ((length - limit - 1) / (length - 1)) * 100;
        const combined_next = response.data.combined.data;
        setPercentage_next(percentages_next);

        console.log("dataprediction", dataPrediction);

        console.log("launchdate", launchDate);
        setNextdata(combined_next);
      });
    }
  }, [prediction, optionone, selectedDistrict]);

  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex ">
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onRedirection}
            />
            <div className="d-flex align-items-center">
              <div
                className="new-box-padding   align-self-center c-pointer"
                onClick={handleFlowPageclick}
                style={{
                  borderBottom: "2px solid #ccc",
                }}
              >
                Flow Analytics
                {datastatusaccontability === true ? (
                  <span className="ms-2" style={{ color: "red" }}>
                    !
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding  text-blue  align-self-center c-pointer "
                onClick={handlePredictivePageclick}
                style={{ borderBottom: "2px solid #1998f0", borderRadius: "0" }}
              >
                Predictive Analytics
              </div>
              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer"
                onClick={handleAnomalypageclick}
                style={{
                  borderBottom: "2px solid #ccc",
                }}
              >
                Anomaly Detection
                {datastatusanomaly === true ? (
                  <span className="ms-2" style={{ color: "red" }}>
                    !
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {/*  */}

        {selectedDistrict === "GPMD" && (
          <div className="d-flex align-items-end">
            <div
              className=""
              style={{ display: "flex", alignItems: "center", width: "450px" }}
            >
              <div
                className="w-100 text-blue total-flow-font-size"
                style={{ textAlign: "end", paddingRight: "15px" }}
              >
                System
              </div>
              <div
                className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
                                              justify-content-center"
              >
                <div className="d-flex w-100">
                  <div className="fs-26 fw-bold d-flex w-100 water">
                    <select
                      name="All"
                      id="selector"
                      className="box"
                      onChange={radioChanges}
                    >
                      {selectedDistrict === "GPMD" ? (
                        <>
                          <option value="non_potable">Non-Potable </option>
                          <option value="potable">Potable</option>
                          <option value="total" selected>
                            Total{" "}
                          </option>
                        </>
                      ) : (
                        <option value="total" selected>
                          Total{" "}
                        </option>
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}

          {/*  */}
        </div>

        <div className="bottom-layout">
          <div className="row mx-0 mt-5">
            <h4 className=" text-blue text-left">
              {" "}
              Flow Prediction - {new Date().getFullYear()}{" "}
            </h4>
            {/* <hr/> */}
            <div className="col-12 col-lg-12">
              <div
                style={{
                  fontSize: "18px",
                  marginTop: "50px",
                  maxWidth: "100%",
                  margin: "0 auto",
                  height: "500px",
                }}
                // className="totalflow-graph"
                className="predictive-graph"
              >
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    // width={1440}
                    // height={500}
                    data={datapredictions}
                    // margin={{ top: 10, right: 20, bottom: 5, left: 0 }}
                    margin={{ top: 10, right: 40, bottom: 60, left: 15 }}
                  >
                    <Line
                      type={type}
                      dataKey="actualvalue"
                      name="Actual Value"
                      stroke="#8884d8"
                      dot={false}
                      strokeWidth={3}
                    />
                    {/* <Line
                      type={type}
                      dataKey="pre_prediction"
                      name="Previous Prediction"
                      stroke="#717D7E"
                      dot={false}
                      strokeDasharray="3 6"
                      strokeWidth={3}
                    /> */}
                    {selectedDistrict === "GPMD" && (
                     <Line
                       type={type}
                       dataKey="pre_prediction"
                       name="Previous Prediction"
                       stroke="#717D7E"
                       dot={false}
                       strokeDasharray="3 6"
                       strokeWidth={3}
                     />
                   )}
                    <Line
                      type={type}
                      dataKey="predictedvalue"
                      name={`Prediction ${currentYear}`}
                      stroke="#82ca9d"
                      dot={false}
                      strokeWidth={3}
                    />
                    {/* <Line type={type} dataKey= "Flow" stroke="url(#gradient)" dot={false} strokeWidth={3}/> */}
                    <XAxis
                      dataKey="week"
                      angle={-40}
                      tick={{ dy: 20 }}
                      style={{ fontSize: "12px" }}
                    />
                    <YAxis
                      tickFormatter={(value) =>
                        typeof value === "number"
                          ? value.toLocaleString("en-IN")
                          : value
                      }
                    >
                      <Label
                        value="Gallons"
                        dx={-10}
                        position="insideLeft"
                        angle={-90}
                        style={{
                          textAnchor: "middle",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                      />
                    </YAxis>
                    <Tooltip
                      formatter={(value) =>
                        typeof value === "number"
                          ? value.toLocaleString("en-IN")
                          : value
                      }
                    />
                    {/* <Legend
                      content={(props) => {
                        const { payload } = props;
                        const l_names = [
                          "Actual Flow",
                          "Previous Prediction",
                          `Prediction ${currentYear}`,
                        ];
                        return (
                          <ul
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              listStyleType: "none",
                              padding: 0,
                            }}
                          >
                            {payload.map((entry, index) => (
                              <li
                                key={`item-${index}`}
                                style={{
                                  color: entry.color,
                                  marginRight: "25px",
                                }}
                              >
                                {l_names[index] || entry.value}
                              </li>
                            ))}
                          </ul>
                        );
                      }}
                    /> */}

                 <Legend
                   content={(props) => {
                     const { payload } = props;
                 
                     return (
                       <ul
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           listStyleType: "none",
                           padding: 0,
                         }}
                       >
                         {payload.map((entry, index) => {
                           let label = entry.value;
                 
                           if (entry.value === "actualvalue") label = "Actual Flow";
                           if (entry.value === "pre_prediction") label = "Previous Prediction";
                           if (entry.value === "predictedvalue")
                             label = `Prediction ${currentYear}`;
                 
                           return (
                             <li
                               key={`item-${index}`}
                               style={{
                                 color: entry.color,
                                 marginRight: "25px",
                               }}
                             >
                               {label}
                             </li>
                           );
                         })}
                       </ul>
                     );
                   }}
                 />
                 
                    {/* <ReferenceLine x={launchDate} label={ optionone == "total" ? " Total System Prediction" : optionone == "potable" ? "Potable System Prediction" : optionone == "non_potable"?"Non Potable System Prediction" : null} /> */}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>{" "}
        </div>

        {/* ------------------------- */}
        <div className="bottom-layout pb-5">
          <div className="col-12 col-lg-12">
            <h4 className="my-4 text-blue text-left">12 - Month Forecast</h4>
            {/* <hr/> */}

            <div
              style={{
                fontSize: "18px",
                marginTop: "50px",
                maxWidth: "100%",
                margin: "0 auto",
                height: "500px",
              }}
              // className="totalflow-graph"
              className="predictive-graph"
            >
              <ResponsiveContainer>
                <LineChart
                  // width={1440}
                  // height={500}
                  data={nextdata}
                  // margin={{ top: 10, right: 20, bottom: 5, left: 0 }}
                  margin={{ top: 10, right: 40, bottom: 60, left: 15 }}
                >
                  <defs>
                    <linearGradient
                      id="gradient"
                      x1="0"
                      y1="0"
                      x2="100%"
                      y2="0"
                    >
                      <stop offset="0%" stopColor="#8884d8" />
                      <stop
                        offset={`${percentage_next}%`}
                        stopColor="#8884d8"
                      />

                      <stop
                        offset={`${percentage_next}%`}
                        stopColor="#82ca9d"
                      />
                      <stop offset="100%" stopColor="#82ca9d" />
                    </linearGradient>
                  </defs>
                  <Line
                    type={type}
                    dataKey="Flow"
                    stroke="url(#gradient)"
                    dot={false}
                    strokeWidth={3}
                  />

                  <XAxis
                    dataKey="week"
                    angle={-40}
                    tick={{ dy: 20 }}
                    style={{ fontSize: "12px" }}
                  />
                  <YAxis
                    tickFormatter={(value) => value.toLocaleString("en-IN")}
                  >
                    <Label
                      value="Gallons"
                      dx={-10}
                      position="insideLeft"
                      angle={-90}
                      style={{
                        textAnchor: "middle",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                    />
                  </YAxis>
                  <Tooltip
                    formatter={(value) => value.toLocaleString("en-IN")}
                  />
                  <Legend
                    content={(props) => {
                      const { payload } = props;
                      const l_names = [" ", "Actual Value", "Predicted Value"];
                      return (
                        <ul
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            listStyleType: "none",
                            padding: 0,
                          }}
                        >
                          {payload.map((entry, index) => (
                            <li
                              key={`item-${index}`}
                              style={{
                                color: entry.color,
                                marginRight: "25px",
                              }}
                            >
                              {l_names[index] || entry.value}
                              {/* {entry.value === 'Flow' ? 'Flow' : entry.value} */}
                            </li>
                          ))}
                        </ul>
                      );
                    }}
                  />
                  {/* <ReferenceLine x={launchDate} label={ optionone == "total" ? " Total System Prediction" : optionone == "potable" ? "Potable System Prediction" : optionone == "non_potable"?"Non Potable System Prediction" : null} /> */}
                </LineChart>
              </ResponsiveContainer>
              <div className="d-flex align-items-center justify-content-center">
                <p
                  className="me-3"
                  style={{ color: "rgb(136, 132, 216)", fontSize: "18px" }}
                >
                  Actual Flow{" "}
                </p>
                <p style={{ color: "rgb(130, 202, 157)", fontSize: "18px" }}>
                  Predicted Flow{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* ----------------------------------- */}
      </Main>
    </>
  );
}

export default Prediction_flow;
